import AvatarAlcoholPoster from "../../../../../images/posters/avatar/best-practices/alcohol.webp";
import AvatarBodyFatPoster from "../../../../../images/posters/avatar/best-practices/body-fat.webp";
import AvatarProteinImportancePoster from "../../../../../images/posters/avatar/best-practices/protein.webp";
import RawVsCookedPoster from "../../../../../images/posters/avatar/education/raw-vs-cooked.webp";
import WeightLossPoster from "../../../../../images/posters/avatar/education/weight-loss.webp";
import MuscleGainPoster from "../../../../../images/posters/avatar/education/muscle-gain.webp";
import ReverseDietPoster from "../../../../../images/posters/avatar/education/reverse-diet.webp";
import MaintenancePoster from "../../../../../images/posters/avatar/education/maintenance.webp";
import DailyVsWeeklyPoster from "../../../../../images/posters/avatar/education/daily-vs-weekly.webp";

const avatarSystemTools = [
  {
    "title": "Why Alcohol is Tracked Differently in the App",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Alcohol.mp4",
    "thumbnail": AvatarAlcoholPoster,
    "length": "5:56"
  },
  {
    "title": "How Body Fat is Used at Check-ins",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Body+Fat.mp4",
    "thumbnail": AvatarBodyFatPoster,
    "length": "11:11"
  },
  {
    "title": "Why Protein Can't Be Swapped in the App",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Protein+Importance.mp4",
    "thumbnail": AvatarProteinImportancePoster,
    "length": "6:39"
  },
  {
    "title": "Should Food Be Weighed Raw or Cooked?",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Raw+vs+Cooked.mp4",
    "thumbnail": RawVsCookedPoster,
    "length": "6:03"
  },
  {
    "title": "Weight Loss Goal Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Weight+Loss.mp4",
    "thumbnail": WeightLossPoster,
    "length": "13:06"
  },
  {
    "title": "Muscle Gain Goal Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Muscle+Gain.mp4",
    "thumbnail": MuscleGainPoster,
    "length": "13:21"
  },
  {
    "title": "Reverse Diet Goal Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Reverse+Diet.mp4",
    "thumbnail": ReverseDietPoster,
    "length": "17:01"
  },
  {
    "title": "Maintenance Goal Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Maintenance.mp4",
    "thumbnail": MaintenancePoster,
    "length": "12:21"
  },
  {
    "title": "Why Weekly Macro Intake Trumps Daily",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Daily+vs+Weekly.mp4",
    "thumbnail": DailyVsWeeklyPoster,
    "length": "9:52"
  },
];

export default avatarSystemTools; 